import { CitizenshipStatus } from '../../../../../../constants'
import { Application } from '../../../../../application/application'

export function isJPNonCitizenGuideStep(application: Application) {
  return application.citizenshipStatus === CitizenshipStatus.OTHERS
}
